import { BERUFE_A } from "@/data/berufe_a";
import { BERUFE_B } from "@/data/berufe_b";

export const BERUFE = [...BERUFE_A, ...BERUFE_B];
